import * as Step from "../../core/script/StepExecutor";

/**
 * Call used to alert UI on progress
 */
export default class EQPauseStepProgress {

    constructor(pause, remaining) {
        this.type = Step.STEP_PAUSE;
        this.pause = pause;
        this.remaining = remaining;
    }
}


// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQPauseStepProgress.js